import { getChildNumsFromHex } from './index';
import { HD, Mnemonic } from '@bsv/sdk';
// deriveChildKeyFromHex derive the child extended key from the hex string
export const deriveChildKeyFromHex = function (hdKey, hexHash) {
    return deriveHDChildKeyFromHex(hdKey, hexHash);
};
export const deriveHDChildKeyFromHex = function (hdKey, hexHash) {
    let childKey = hdKey;
    const childNums = getChildNumsFromHex(hexHash);
    childNums.forEach((childNum) => {
        childKey = childKey.deriveChild(childNum);
    });
    return childKey;
};
export const generateKeys = function () {
    const mnemonic = Mnemonic.fromRandom();
    return getKeysFromMnemonic(mnemonic.toString());
};
export const getKeysFromMnemonic = function (mnemonicStr) {
    const mnemonic = Mnemonic.fromString(mnemonicStr);
    const seed = mnemonic.toSeed();
    const hdWallet = new HD().fromSeed(seed);
    return {
        xPriv: () => hdWallet.toString(),
        mnemonic: mnemonic.toString(),
        xPub: {
            toString() {
                return hdWallet.toPublic().toString();
            },
        },
    };
};
export const getKeysFromString = function (privateKey) {
    let hdWallet = new HD().fromString(privateKey);
    return {
        xPriv: () => hdWallet.privKey.toString(),
        xPub: {
            toString() {
                return hdWallet.toPublic().toString();
            },
        },
    };
};
